import { IOptionLists } from "../../components/filter-chips/filter-chips.props";

import { reduceValues } from "../filters.functions";
import { notFlag } from "../filters.constants";

export const paramsToValues = (params: any, options: IOptionLists) => {
  let statusInverted = false;
  if (params.status) {
    statusInverted = params.status[0].substr(0, notFlag.length) === notFlag;
    params.status[0] = params?.status[0]?.replace(notFlag, "") ?? undefined;
  }

  const values = reduceValues(params, options);

  return {
    briefOwner: null,
    dateFrom: "",
    dateTo: "",
    regions: [],
    status: null,
    template: null,
    ...values,
    statusInverted,
  };
};
